import { useEffect } from 'react';
import { create } from 'zustand';
import { listOpenAgentProposals } from '../../../lib/itemClassificationService';
import type { ItemClassificationProposal } from '../../../types/prioritization/itemClassification';
import { getCurrentWorkspaceId } from '../../../lib/supabaseSync';

interface OpenClassificationState {
  byAgent: Record<string, ItemClassificationProposal[]>;
  load: (workspaceId: string, agentType: string) => Promise<void>;
}

/** Open classification proposals per agent, read from the database; reload after every decision. */
export const useOpenClassificationStore = create<OpenClassificationState>()((set) => ({
  byAgent: {},
  load: async (workspaceId, agentType) => {
    const { data } = await listOpenAgentProposals(workspaceId, agentType);
    set((s) => ({ byAgent: { ...s.byAgent, [agentType]: data } }));
  },
}));

const EMPTY: ItemClassificationProposal[] = [];

/** Every classification this agent proposed that still waits for a person, newest first. */
export function useOpenClassificationProposals(agentType: string): ItemClassificationProposal[] {
  const open = useOpenClassificationStore((s) => s.byAgent[agentType] ?? EMPTY);
  const load = useOpenClassificationStore((s) => s.load);
  const workspaceId = getCurrentWorkspaceId();
  useEffect(() => {
    if (workspaceId) void load(workspaceId, agentType);
  }, [workspaceId, agentType, load]);
  return open;
}
